var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMMulticolor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38571_166355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2147 8.48245C14.2147 7.90805 13.5434 7.61965 13.1506 8.02605L10.1627 11.1169C9.9209 11.3673 9.78516 11.7065 9.78516 12.0597V21.3561C9.78516 21.9309 10.4565 22.2189 10.8492 21.8125L13.8372 18.7221C14.0789 18.4717 14.2147 18.1325 14.2147 17.7793V8.48285V8.48245Z",
    fill: "url(#paint0_linear_38571_166355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05203 18.7337L5.06406 21.8105C4.6713 22.2149 4 21.9289 4 21.3561V18.0573C4 17.7045 4.13614 17.3669 4.37751 17.1177L7.36548 14.0409C7.75824 13.6365 8.42954 13.9225 8.42954 14.4953V17.7941C8.42954 18.1469 8.2934 18.4845 8.05203 18.7337Z",
    fill: "url(#paint1_linear_38571_166355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6223 6.02892L16.6344 9.12412C16.2416 9.53092 15.5703 9.24332 15.5703 8.66692V6.23092C15.5703 5.87612 15.7065 5.53612 15.9478 5.28572L18.9358 2.19052C19.3286 1.78372 19.9998 2.07132 19.9998 2.64772V5.08372C19.9998 5.43852 19.8637 5.77852 19.6223 6.02892Z",
    fill: "url(#paint2_linear_38571_166355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6344 10.9865C16.2416 11.3953 15.5703 11.1061 15.5703 10.5273V21.3477C15.5703 21.9257 16.2416 22.2157 16.6344 21.8069L19.6223 18.6981C19.8641 18.4465 19.9998 18.1049 19.9998 17.7493V7.46094L16.6336 10.9873L16.6344 10.9865Z",
    fill: "url(#paint3_linear_38571_166355)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38571_166355",
    x1: 7.56746,
    y1: 12.1581,
    x2: 18.7557,
    y2: 18.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F42D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C12879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8682D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38571_166355",
    x1: 4.69946,
    y1: 16.9817,
    x2: 15.8806,
    y2: 23.6434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F42D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C12879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8682D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38571_166355",
    x1: 13.1531,
    y1: 2.77212,
    x2: 24.3319,
    y2: 9.43267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F42D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C12879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8682D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38571_166355",
    x1: 9.27007,
    y1: 9.28494,
    x2: 20.4587,
    y2: 15.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F42D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C12879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8682D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38571_166355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMMulticolor);
export default __webpack_public_path__ + "static/media/M_Multicolor.b37afa761b55978e6f5a8d4f3614af64.svg";
export { ForwardRef as ReactComponent };